var templates = (<any>require).context('../', true, /\.html$/);
templates.keys().forEach(function(key) {
  templates(key);
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/partials.ts